import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { withLastLocation } from 'react-router-last-location';

import MaxWidth from '../../components/max-width';
import Blocks from '../../components/blocks';
import store, { loadProject } from '../../state';

import './project.css';

function getSlug(branch) {
  if (branch.slug) return branch.slug;

  if (typeof branch.match !== 'undefined' &&
        typeof branch.match.params !== 'undefined') {
    return branch.match.params.slug;
  }

  if (typeof branch.route !== 'undefined' &&
        typeof branch.route.data !== 'undefined' &&
        branch.route.data.slug) {
    return branch.route.data.slug;
  }
  return null;
}

const infoFields = [
  ['artist', 'Artist'],
  ['client', 'Client'],
  ['year', 'Year'],
];

class Project extends Component {
  static fetchData(dispatch, branch) {
    return dispatch(loadProject(getSlug(branch)));
  }

  constructor(props) {
    super(props);
    this.state = {
      slug: getSlug(props),
    };
  }

  componentDidMount() {
    const { node } = this.props;
    if (!node) {
      store.dispatch(loadProject(this.state.slug));
    }
  }

  goBack = (e) => {
    e.preventDefault();
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { node } = this.props;
    if (!node) return null;

    // info fields
    const fields = node.get('fields');
    const info = [];

    info.push((
      <div className="field field-text" key="field-info-tile">
        <div className="label">Title</div>
        <div className="value">{node.get('title')}</div>
      </div>
    ));

    infoFields.forEach((field) => {
      const value = fields.getIn([field[0], 'value']);
      if (value) {
        info.push((
          <div className="field field-text" key={`field-info-${field[0]}`}>
            <div className="label">{field[1]}</div>
            <div className="value">{value}</div>
          </div>
        ));
      }
    });

    const production = fields.getIn(['production', 'value']);
    const description = fields.getIn(['description', 'value']);

    return (
      <MaxWidth className={`page-type-project project-${this.state.slug}`}>
        <div className="page-title project-header">
          <div className="project-info">
            <div className="block-info">
              {info}
            </div>
            {description ? <div className="description-text" dangerouslySetInnerHTML={{ __html: description }} /> : null}
          </div>
          <div className="production-details">
            <h3>Production Details</h3>
            <div className="production-text" dangerouslySetInnerHTML={{ __html: production }} />
          </div>
        </div>
        <div className="page-content">
          <Blocks blocks={node.get('blocks')} />
        </div>
        <div className="back">
          <Link to={`/works/projects`}>Back to selected works</Link>
        </div>
        <Helmet>
          <title>DCG Design | {node.get('title')}</title>
        </Helmet>
      </MaxWidth>
    );
  }
}

Project.propTypes = {
  node: PropTypes.instanceOf(Map),
  history: PropTypes.object.isRequired,
};

Project.defaultProps = {
  node: null,
};

const mapStateToProps = (state, ownProps) => {
  const slug = getSlug(ownProps);
  const node = state.getIn(['projects', slug]);

  return {
    node,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({ loadProject }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withLastLocation(Project));




// WEBPACK FOOTER //
// ./src/containers/project/index.jsx